const PROMOTION = "promotion";
const ABANDONED_CART = "abandoned-cart";
const WALLET_BALANCE_EXPIRY = "wallet-balance-expiry";

export { PROMOTION, ABANDONED_CART, WALLET_BALANCE_EXPIRY };
